export enum CoroIcons {
  CLOUD_SECURITY = "cloudApps",
  BACKUP_AND_RESTORE = "backupAndRestoreL",
  CLOUD_APPS = "cloudAppsNoHexagon",
  PHISHING = "phishing",
  EMAIL_SECURITY = "emailSecurity",
  MALWARE = "malware",
  ADMIN_USERS = "adminUsers",
  ACTIVITY_LOGS = "activityLogs",
  PROTECTED_USERS = "usersNoHexagon",
  DEVICES = "devicesNoHexagon",
  ENDPOINT_SECURITY = "devices",
  EMAIL = "email",
  EMAILS = "emails",
  USER_DATA_GOVERNANCE = "data",
  EMAIL_PROXY = "accessRestrictions",
  CONNECTORS = "connectors",
  REPORTS = "dataNoHexagon",
  NETWORK = "addonNetwork",
  ENDPOINT_DATA_GOVERNANCE = "endpointDataGovernance",
  ALLOW_BLOCK_LISTS = "allowBlockListsLarge",
  EDR = "edrHexagon",
  MOBILE_DEVICE_MANAGEMENT = "mdm",
  BILLING = "billing",
  SOC = "socSettings",
  SECURITY_AWARENESS = "securityAwareness",
  LABEL = "label",
  GATEWAY_SETTINGS = "proxySettings",
  CLOUD_XS = "cloud",
  DEVICE_XS = "laptop",
  USER_DATA_GOVERNANCE_SM = "userDataSm",
  AI_ASSISTANT = "aiAssistant",
  AI_ASSISTANT_STAR = "aiAssistantStar",
  NETWORK_SETTINGS = "dns",
  NETWORK_SETTINGS_L = "networkNoHexagonL",

  DEVICE_S = "deviceS",
  NETWORK_S = "networkS",
  SECURITY_AWARENESS_S = "securityAwarenessTrainingS",
  EMAIL_S = "emailS",
  DATA_S = "dataS",
  ENDPOINT_DATA_GOVERNANCE_S = "endpointDataGovernanceS",
  MDM_SM = "mdmSm",
  CLOUD_APP_S = "cloudAppS",
  EDR_S = "edrS",
  ZTNA_S = "ztnaS",
  INBOUND_GATEWAY = "inboundGateway",
  OUTBOUND_GATEWAY = "outboundGateway",
  DNS_ALTERNATIVE_S = "dnsAlternativeS",
  BACKUP_AND_RESTORE_S = "backupAndRestoreS",
  WIFI_PHISHING_S = "wifiPhishingS",
  SECURE_MESSAGE_S = "secureMessagesS",
  SUSPICIOUS_EMAIL_CONTENT_S = "suspiciousEmailContentS",
}
